import React, { useEffect, useRef, useState } from "react";
import OCR from "../ocr.svg";
import "./SubHeader.css";
import { useCenter } from "../context/CenterContext";
import CentreSwitcherModal from "./CentreSwitcherModal";

const SubHeader = () => {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { centerName, centerNumber, user } = useCenter(); // user already in context

  const dropdownRef = useRef(null);

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Local helper (no context changes needed)
  const displayName =
    user?.name ||
    user?.preferred_username ||
    [user?.given_name, user?.family_name].filter(Boolean).join(" ") ||
    user?.email ||
    "User";

  const handleGoToMyCambridge = () => {
    localStorage.removeItem('selectedCentreId'); // Remove selected center from localStorage
    window.location.href = process.env.REACT_APP_MY_CAMBRIDGE_HOMEPAGE; // Navigate to My Cambridge
  };

  return (
    <>
      <CentreSwitcherModal isOpen={showModal} onClose={() => setShowModal(false)} />
      <header className="site-brand-header" id="siteBrandHeader">
        <div className="product-brand-logo pt-1" id="pnlLogoOCR">
          <img src={OCR} alt="OCR Icon" />
        </div>

        <div className="brand-header-divider"></div>

        <div
          className="brand-header-product-title override-product-title"
          id="varProductTitle"
        >
          Moderation Service
        </div>
        <nav
          className="navbar is-pulled-right"
          role="navigation"
          aria-label="dropdown navigation"
        >
          <div
            className={`navbar-item has-dropdown identity ${
              isDropdownOpen ? "is-active" : ""
            }`}
            ref={dropdownRef}
          >
            <a
              className="button navbar-link"
              id="varSignedInName"
              href="#userMenu"
              role="button"
              aria-haspopup="menu"
              aria-controls="userMenu"
              onClick={toggleDropdown}
            >
              <span className="icon identity-avatar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ fill: "#767676" }}
                  height="32"
                  viewBox="0 -960 960 960"
                  width="32"
                >
                  <path d="M222-255q63-40 124.5-60.5T480-336q72 0 134 20.5T739-255q44-54 62.5-109T820-480q0-145-97.5-242.5T480-820q-145 0-242.5 97.5T140-480q0 61 19 116t63 109Zm257.814-195Q422-450 382.5-489.686q-39.5-39.686-39.5-97.5t39.686-97.314q39.686-39.5 97.5-39.5t97.314 39.686q39.5 39.686 39.5 97.5T577.314-489.5q-39.686 39.5-97.5 39.5Zm-.219 370q-83.146 0-156.275-31.5t-127.225-86Q142-252 111-324.841 80-397.681 80-480.5q0-82.819 31.5-155.659Q143-709 197.5-763t127.341-85.5Q397.681-880 480.5-880q82.819 0 155.659 31.5Q709-817 763-763t85.5 127Q880-563 880-480.266q0 82.734-31.5 155.5T763-197.5q-54 54.5-127.129 86T479.595-80Z"></path>
                </svg>
              </span>
              <span className="identity-signed-in-name">
                {displayName}
              </span>
            </a>
            <div className="navbar-dropdown is-right">
              <div className="pl-2" id="varUserRoles">
                <div className="columns is-gapless is-align-items-center">
                  <div className="column is-narrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ fill: "#767676" }}
                      height="48"
                      viewBox="0 -960 960 960"
                      width="48"
                    >
                      <path d="M222-255q63-40 124.5-60.5T480-336q72 0 134 20.5T739-255q44-54 62.5-109T820-480q0-145-97.5-242.5T480-820q-145 0-242.5 97.5T140-480q0 61 19 116t63 109Zm257.814-195Q422-450 382.5-489.686q-39.5-39.686-39.5-97.5t39.686-97.314q39.686-39.5 97.5-39.5t97.314 39.686q39.5 39.686 39.5 97.5T577.314-489.5q-39.686 39.5-97.5 39.5Zm-.219 370q-83.146 0-156.275-31.5t-127.225-86Q142-252 111-324.841 80-397.681 80-480.5q0-82.819 31.5-155.659Q143-709 197.5-763t127.341-85.5Q397.681-880 480.5-880q82.819 0 155.659 31.5Q709-817 763-763t85.5 127Q880-563 880-480.266q0 82.734-31.5 155.5T763-197.5q-54 54.5-127.129 86T479.595-80Z"></path>
                    </svg>
                  </div>
                  <div className="column has-text-left">
                    <span className="has-text-weight-bold pl-2">
                      {displayName}
                    </span>
                  </div>
                </div>
              </div>
              <div id="pnlIdentityCentreInfo" style={{ display: "block" }}>
                <hr className="navbar-divider" />
                <div
                  className="navbar-item has-text-weight-bold is-flex-direction-column is-justify-content-flex-start"
                  id="varUserRoles"
                >
                  <div className="is-size-7">Signed in to centre:</div>
                  <div>
                    {centerNumber ? centerNumber : ""}
                    <br />
                    {centerName ? centerName : ""}
                  </div>
                </div>
              </div>
              <hr className="navbar-divider" />
              <ul className="menu-list" id="navSideMenu2">
                <li>
                  <a
                    href="#"
                    data-target="modal-centre-switcher"
                    id="btnIdentityMenuChangeCentre"
                    onClick={(e) => {
                      e.preventDefault();
                      setShowModal(true);
                    }}
                  >
                    Change centre
                  </a>
                </li>
                <li id="pnlIdentityGoToMyCam" style={{ display: "block" }}>
                  <a
                    id="btnBackToMyCam"
                    onClick={handleGoToMyCambridge}
                  >
                    Go to My Cambridge
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default SubHeader;
